import { Types } from "@inrev/common";
import { useIsCommercialSuretyEnabled } from "./useIsCommercialSuretyEnabled";

export const obligeeRoleOptionsFor = (isCommercialSuretyEnabled: boolean) =>
	isCommercialSuretyEnabled
		? Types.SuretyBond.Obligee.roleOptions
		: Types.SuretyBond.Obligee.contractRoleOptions;

export const useObligeeRoleOptions = () => obligeeRoleOptionsFor(useIsCommercialSuretyEnabled());
